import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AdminBaseEditComponent } from 'src/modules/sm-base/components/admin-base-edit/admin-base-edit.component';
import { FrontendField } from 'src/modules/sm-base/netgen/FrontendField';
import { FrontendFieldType } from 'src/modules/sm-base/netgen/FrontendFieldType';
import { FrontendForm } from 'src/modules/sm-base/netgen/FrontendForm';
import { ProjectPlanningTools } from '../../models/project-planning-tools.model';
import { CalendarOutlineLevel } from '../../netgen/CalendarOutlineLevel';

@Component({
    selector: 'app-edit-calendar-outline-level',
    templateUrl: '../../../sm-base/components/admin-base-edit/admin-base-edit.component.html',
    styleUrl: '../../../sm-base/components/admin-base-edit/admin-base-edit.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditCalendarOutlineLevelComponent extends AdminBaseEditComponent<CalendarOutlineLevel> {

    definition = ProjectPlanningTools.definitionCalendarOutlineLevel;

    getForm(): FrontendForm {
        return this.app.tForm("entity.CalendarOutlineLevel.fields", new FrontendForm([
            new FrontendField("title", "", FrontendFieldType.string, { mandatory: true })             
        ]));
    }
    
}
